import { httpGet } from "@/utils/axios";
import urls from "@/utils/URLConstant";

export async function fetchRestaurantById(
  restaurantId: string,
  reservationId: string,
) {
  if (!restaurantId) {
    throw new Error("restaurantId is required to fetch restaurant");
  }
  const response = await httpGet(
    urls.PREORDER.restaurant(restaurantId, reservationId),
  );
  return response.data;
}

/**
 * FOYR-431 — `POST /preorder/modifications/byIds` was NOT ported to the
 * consolidated backend (modifiers are out of the product; every served menu
 * item carries `modifiers: []`, so `SingleItemPage` never reaches this call
 * for real data). Kept as a local no-op so the call site and its test keep
 * compiling; it makes no network request.
 */
export async function fetchModificationsByIds(
  _modificationIds: string[],
): Promise<any[]> {
  return [];
}

const restaurantService = { fetchRestaurantById, fetchModificationsByIds };
export default restaurantService;
